module.exports = __webpack_public_path__ + "img/lamer_logo_header.8f1c04c0.png";